var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tag
    ? _c(
        "div",
        [
          _c("div", { staticClass: "dashboard-page-title" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("h1", [_vm._v("Tag Management: " + _vm._s(_vm.tag.name))]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-info",
                    attrs: { "active-class": "" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-chevron-left" }),
                    _vm._v(" Back\n        "),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "dashboard-block" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "panel panel-grey" }, [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("h2", [_vm._v("Children")]),
                        _vm._v(" "),
                        _vm.tag.tag_type
                          ? _c("tags", {
                              attrs: {
                                id: _vm.tag.id,
                                tagType: _vm.tag.tag_type,
                              },
                              model: {
                                value: _vm.tag.child_tags,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tag, "child_tags", $$v)
                                },
                                expression: "tag.child_tags",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        click: _vm.handleSaveTagsCallback,
                      },
                    },
                    [_vm._v("\n          Save Changes\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "dashboard-block" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "panel panel-grey" }, [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("h2", [_vm._v("PARENTS")]),
                        _vm._v(" "),
                        _vm.tag.tag_type
                          ? _c("tags", {
                              attrs: {
                                id: _vm.tag.id,
                                tagType: _vm.tag.tag_type,
                              },
                              model: {
                                value: _vm.tag.parent_tags,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tag, "parent_tags", $$v)
                                },
                                expression: "tag.parent_tags",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        click: _vm.handleSaveTagsCallback,
                      },
                    },
                    [_vm._v("\n          Save Changes\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "dashboard-block" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "panel panel-grey" }, [
                  _c("div", { staticClass: "panel-body" }, [
                    _c("h2", [_vm._v("Synonyms")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.synonym,
                              expression: "synonym",
                            },
                          ],
                          staticClass: "form-control input-sm",
                          attrs: { name: "alias", type: "text" },
                          domProps: { value: _vm.synonym },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.synonym = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-3" },
                        [
                          _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-success inactive",
                              attrs: { click: _vm.handleAddSynonymCallback },
                            },
                            [_vm._v("Add Synonym\n                ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "talent-list" },
                      _vm._l(_vm.tag.synonyms, function (synonym, index) {
                        return _c("li", { key: index }, [
                          _c("div", { staticClass: "flex-row" }, [
                            _c("div", { staticClass: "col-xs-9" }, [
                              _c("p", [_vm._v(_vm._s(synonym))]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-xs-3" },
                              [
                                _c(
                                  "ladda-button",
                                  {
                                    staticClass:
                                      "btn circle-btn btn-danger inactive",
                                    attrs: {
                                      click: _vm.handleDeleteSynonymCallback,
                                      arguments: [index],
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-trash" }),
                                    _vm._v(
                                      " Delete Synonym\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "dashboard-block" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "panel panel-grey" }, [
                  _c("div", { staticClass: "panel-body" }, [
                    _c("h2", [_vm._v("Translations")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.translation,
                              expression: "translation",
                            },
                          ],
                          staticClass: "form-control input-sm",
                          attrs: { name: "alias", type: "text" },
                          domProps: { value: _vm.translation },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.translation = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-3" },
                        [
                          _c("selectize", {
                            ref: "regions",
                            staticClass: "selectize selectize-single",
                            attrs: {
                              name: "region",
                              placeholder: "Region",
                              options: _vm.filteredRegionsOptions,
                            },
                            model: {
                              value: _vm.region,
                              callback: function ($$v) {
                                _vm.region = $$v
                              },
                              expression: "region",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-3" },
                        [
                          _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-success inactive",
                              attrs: {
                                click: _vm.handleAddTranslationCallback,
                              },
                            },
                            [_vm._v("Add Translation\n                ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "talent-list" },
                      _vm._l(
                        _vm.tag.translations,
                        function (translation, region) {
                          return _c("li", { key: region }, [
                            _c("div", { staticClass: "flex-row" }, [
                              _c("div", { staticClass: "col-xs-9" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(region) +
                                    " - " +
                                    _vm._s(translation) +
                                    "\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-xs-3" },
                                [
                                  _c(
                                    "ladda-button",
                                    {
                                      staticClass:
                                        "btn circle-btn btn-danger inactive",
                                      attrs: {
                                        click: () => {
                                          _vm.handleDeleteTranslationCallback(
                                            region
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-trash" }),
                                      _vm._v(
                                        " Delete Translation\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "div",
              { staticClass: "dashboard-block" },
              [
                _c("h2", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural)) +
                      "\n        "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        "data-toggle": "modal",
                        "data-target": "#add-tag-talent",
                      },
                      on: { click: _vm.toggleAddTalent },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary pull-right m-t-h2-btn",
                        },
                        [
                          _c("i", { staticClass: "fa fa-fw fa-plus" }),
                          _vm._v(
                            " Add " +
                              _vm._s(
                                _vm._f("sentenceCase")(_vm.$starLabelPlural)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.fetching
                  ? _c("pickstar-loading", { staticClass: "m-lg" })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.fetchingTags
                  ? _c(
                      "div",
                      [
                        !_vm.fetching && _vm.tagTalent && _vm.tagTalent.length
                          ? _c(
                              "ul",
                              { staticClass: "talent-list" },
                              _vm._l(_vm.tagTalent, function (talent) {
                                return _c("li", { key: talent.id }, [
                                  _c("div", { staticClass: "flex-row" }, [
                                    _c("div", { staticClass: "col-xs-6" }, [
                                      _c("p", [_vm._v(_vm._s(talent.name))]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-xs-6",
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [
                                        _c(
                                          "ladda-button",
                                          {
                                            staticClass:
                                              "btn circle-btn btn-danger-outline inactive",
                                            attrs: {
                                              click:
                                                _vm.handleRemoveTalentFromTagCallback,
                                              arguments: [talent],
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-trash",
                                            }),
                                            _vm._v(
                                              " Remove From Tag\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("system-tag-management-single-pagination", {
                          attrs: { pagination: _vm.pagination },
                          on: { changePage: _vm.handleUpdatePagination },
                        }),
                        _vm._v(" "),
                        !_vm.tagTalent || !_vm.tagTalent.length
                          ? _c("div", { staticClass: "panel panel-default" }, [
                              _c("div", { staticClass: "panel-body" }, [
                                _vm._v(
                                  "\n            No " +
                                    _vm._s(_vm.$starLabelPlural) +
                                    " currently assigned to this tag.\n          "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "text-center" }, [
                      _c("i", {
                        staticClass:
                          "fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("system-add-talent-tag-modal", {
            attrs: { tag: _vm.tag },
            on: {
              addTagTalent: _vm.addTagTalent,
              removeTagTalent: _vm.removeTagTalent,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }